import React from "react";
import Home from "./pages/Home";
import Cfp from "./pages/Cfp";
import Committee from "./pages/Committee";
import Guidelines from "./pages/Guidelines";
import Past from "./pages/Past";
import { Route, Routes } from "react-router-dom";
import SpecialSession from "./pages/SpecialSession";
import ReviewProcess from "./pages/ReviewProcess";

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/special-session" element={<SpecialSession />} />
      <Route path="/committee" element={<Committee />} />
      <Route path="/cfp" element={<Cfp />} />
      <Route path="/past-conf" element={<Past />} />
      <Route path="/guidelines" element={<Guidelines />} />
      <Route path="/review-process" element={<ReviewProcess />} />
    </Routes>
  );
};

export default App;
